const ENV_DOMAINS = [
  { match: 'forever.com',      env: 'production' },
  { match: 'staging4ever.com', env: 'staging'    },
  { match: 'sandbox4ever.com', env: 'sandbox'    },
];

function resolveEnv(hostname, serverEnv) {
  const bare = hostname.split(':')[0].toLowerCase();
  for (const {match, env} of ENV_DOMAINS) {
    if (bare === match || bare.endsWith(`.${match}`)) return env;
  }
  return serverEnv || 'sandbox';
}

/**
 * Returns the public runtime config value matching the current environment.
 *
 * @param {{ sandbox: string, staging: string, production: string }} keyMap
 *   Map from environment name to runtime config key (as defined in conf/public-runtime.js).
 *
 * @example
 * useEnvConfig({
 *   sandbox:    'authClientIdSandbox',
 *   staging:    'authClientIdStaging',
 *   production: 'authClientIdProduction',
 * })
 */
export function useEnvConfig(keyMap) {
  const config = useRuntimeConfig().public;
  const env = resolveEnv(useRequestURL().hostname, config.serverEnv);
  return config[keyMap[env]] ?? config[keyMap.sandbox];
}
